import { captureException } from '@sentry/react';
import type { QueryClient } from '@tanstack/react-query';

import { apiClient, hasStatusPage } from 'api/ApiClient';
import { isServerError } from 'api/BaseApiClient';
import type { UnresolvedIncident, UnresolvedIncidentResponse } from 'api/types';

export const QueryKeys = {
  getStatusPageIncidents: 'getStatusPageIncidents',
};

const getStatusPageIncident = async (queryClient: QueryClient) => {
  const incidents = queryClient.getQueryData<UnresolvedIncidentResponse>([QueryKeys.getStatusPageIncidents]);
  const incident = incidents?.at(0);

  if (incident) {
    return incident;
  }

  return await queryClient
    .fetchQuery<UnresolvedIncidentResponse>({
      queryKey: [QueryKeys.getStatusPageIncidents],
      queryFn: () => apiClient.getStatusPageIncidents(),
    })
    .then((incidents) => incidents?.at(0));
};

export const checkForStatusPageIncident = async (props: {
  queryClient: QueryClient;
  error: unknown;
}): Promise<UnresolvedIncident | null> => {
  const { queryClient, error } = props;

  if (!hasStatusPage || !isServerError(error)) {
    return null;
  }

  try {
    const incident = await getStatusPageIncident(queryClient);
    if (incident) {
      return incident;
    }
  } catch (error) {
    captureException(error);
  }

  return null;
};
